









































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios, { AxiosResponse } from "axios";

import GerencialDiretivoService from "@/service/relatorio/gerencial/GerencialDiretivoService";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import { statusServicosDiretivo } from "@/models/administracao/diretivo/StatusServicosDiretivo";
import {
  tipoServicoVeicularList,
  tipoServicoSaudeList,
  TipoServicoModel,
} from "@/models/commons/TipoServicoModel";
import { RelatorioDiretivoModel } from "@/models/administracao/diretivo/RelatorioDiretivoModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { PaginationModel } from "@/models/commons/PaginationModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioDiretivo extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };

  headers = [
    { text: 'Data Base', value: 'dataBase', width: '150px' },
    { text: 'Codigo Cliente', value: 'codigoCliente', width: '200px' },
    { text: 'Titular/Dependente', value: 'titular', width: '100px' },
    { text: 'Perfil', value: 'perfil', width: '250px' },
    { text: 'Nome do Cliente', value: 'nomeCliente', width: '300px' },
    { text: 'Data Nascimento', value: 'dataNascimento', width: '150px' },
    { text: 'Genero', value: 'genero', width: '150px' },
    { text: 'Cidade', value: 'cidadeCliente', width: '150px' },
    { text: 'Estado', value: 'estadoCliente', width: '150px' },
    { text: 'Data Cadastro', value: 'dataCadastroCliente', width: '150px' },
    { text: 'Data Venda', value: 'dataVenda', width: '150px' },
    { text: 'Serviço Vendido', value: 'servicoVendido', width: '150px' },
    { text: 'Descrição Serviço', value: 'descricaoServico', width: '150px' },
    { text: 'Status Serviço', value: 'statusServico', width: '150px' },
    { text: 'Valor Cobrado', value: 'valorCobrado', width: '150px' },
    { text: 'Meio Pagamento', value: 'meioPagamento', width: '150px' },
    { text: 'Parcelas', value: 'parcelas', width: '150px' },
    { text: 'Bandeira', value: 'bandeira', width: '150px' },
    { text: 'Data Prestação', value: 'dataPrestacao', width: '150px' },
    { text: 'Código Prestador', value: 'codigoPrestador', width: '150px' },
    { text: 'Nome Prestador', value: 'nomePrestador', width: '150px' },
    { text: 'Cidade Prestador', value: 'cidadePrestador', width: '150px' },
    { text: 'Estado Prestador', value: 'estadoPrestador', width: '150px' },
    { text: 'Data Cadastro', value: 'dataCadastroPrestador', width: '150px' },
    { text: 'Valor Pago Prestador', value: 'valorPagoPrestador', width: '150px' },
    { text: 'Cidade Prestação', value: 'cidadePrestacaoServico', width: '150px' },
    { text: 'Avaliação do Serviço', value: 'avaliacaoServico', width: '150px' },
    { text: 'Código do Agente', value: 'codigoAgente', width: '150px' },
    { text: 'Nome do Agente', value: 'nomeAgente', width: '150px' },
    { text: 'Cidade do Agente', value: 'cidadeAgente', width: '150px' },
    { text: 'Estado do Agente', value: 'estadoAgente', width: '150px' },
    { text: '% da Comissão', value: 'porcComissao', width: '150px' },
    { text: '$ da Comissão', value: 'valorComissao', width: '150px' },
    { text: 'Data Pagamento', value: 'dataPagamentoComissao', width: '150px' },
  ];
  items = [];

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsible = 0;
  exibirLista = false;
  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  cidadesPrestador: string[] = [];
  cidadesServico: string[] = [];
  cidadesAgente: string[] = [];
  tipoCliente = [
    { name: "TITULAR", descricao: "Titular" },
    { name: "DEPENDENTE", descricao: "Dependente" },
  ];
  tipoServicos = [
    { name: "VEICULAR", descricao: "Veicular" },
    { name: "SAUDE", descricao: "Saúde" },
  ];
  descricaoServicos: TipoServicoModel[] = [];
  perfis = [
    { name: "FISICA", descricao: "Pessoa Física" },
    { name: "JURIDICA", descricao: "Pessoa Jurídica" },
  ];
  generos = [
    { name: "FEMININO", descricao: "Feminino" },
    { name: "MASCULINO", descricao: "Masculino" },
  ];
  status = [...statusServicosDiretivo];
  bandeiras = [
    { name: "MASTERCARD", descricao: "MasterCard" },
    { name: "VISA", descricao: "Visa" },
    { name: "HIPERCARD", descricao: "Hipercard" },
    { name: "DISCOVER", descricao: "Discover" },
    { name: "DINERS", descricao: "Diners" },
    { name: "ELO", descricao: "Elo" },
    { name: "AMEX", descricao: "Amex" },
  ];
  meiosPagamento = [{name: 'CARTAO_CREDITO', descricao: 'Cartão de Crédito'}];

  relatorio: RelatorioDiretivoModel = {
    dataInicio: undefined,
    dataFim: undefined,
  };

  mounted() {
    axios
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));
  }

  getData() {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialDiretivoService.diretivoDados(this.relatorio)
          .then((res) => {
            this.loading = false;
            this.exibirLista = true;
            this.items = res.data;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
            this.exibirLista = false;
          });

        //this.limparformulario();
      }
    });
  }

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialDiretivoService.gerarRelatorio(tipo, this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `relatorio_diretivo.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  // @Watch("relatorio.servicoVendido")
  // private selectDescricaoServico(): void {
  //   let aux: any[] = [];
  //   this.relatorio.servicoVendido?.forEach((serv) => {
  //     aux =
  //       serv.name === "SAUDE"
  //         ? [...tipoServicoSaudeList, ...aux]
  //         : [...tipoServicoVeicularList, ...aux];
  //   });
  //   this.descricaoServicos = aux;
  // }

  // @Watch("relatorio.estadoCliente")
  // private selectCitiesCustomer(): void {
  //   if (this.relatorio.estadoCliente) {
  //     this.cidades = this.estados.filter(
  //       (v) => v.sigla === this.relatorio.estadoCliente?.sigla
  //     )[0].cidades;
  //   }
  // }

  // @Watch("relatorio.estadoPrestador")
  // private selectCitiesProvider(): void {
  //   if (this.relatorio.estadoPrestador) {
  //     this.cidadesPrestador = this.estados.filter(
  //       (v) => v.sigla === this.relatorio.estadoPrestador?.sigla
  //     )[0].cidades;
  //   }
  // }

  // @Watch("relatorio.estadoPrestacaoServico")
  // private selectCitiesService(): void {
  //   if (this.relatorio.estadoPrestacaoServico) {
  //     this.cidadesServico = this.estados.filter(
  //       (v) => v.sigla === this.relatorio.estadoPrestacaoServico?.sigla
  //     )[0].cidades;
  //   }
  // }

  // @Watch("relatorio.estadoAgente")
  // private selectCitiesAgent(): void {
  //   if (this.relatorio.estadoAgente) {
  //     this.cidadesAgente = this.estados.filter(
  //       (v) => v.sigla === this.relatorio.estadoAgente?.sigla
  //     )[0].cidades;
  //   }
  // }

  public toggleCollapsible(value: number): void {
    this.collapsible = value === this.collapsible ? 0 : value;
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }

}
